import { Card, Table, TableColumnsType } from "antd";
import { useSearchTableNew } from "hooks/otros/useSearchTableNew";
import { farmaciaStock } from "hooks/productos/useVisorMartillo";

const StockFarmaciasTable: React.FC<{ dataStock: farmaciaStock[]; loader: boolean }> = ({ dataStock, loader }) => {
  const { getColumnSearchPropsNew: getColumnStock } = useSearchTableNew<farmaciaStock>();

  const columnsBodegaStock: TableColumnsType<farmaciaStock> = [
    {
      title: "Bodega",
      dataIndex: "Bodega",
      className: "letraPequenaVisor",
      key: "Bodega",
      width: "170px",
      fixed: "left",
      ...getColumnStock("Bodega"),
    },
    {
      title: "Cajas",
      dataIndex: "cajas",
      className: "letraPequenaVisor",
      key: "cajas",
      fixed: "left",
      sorter: (a, b) => a.cajas - b.cajas,
      sortDirections: ["descend", "ascend"],
      // ...getColumnStock("cajas"),
    },
    {
      title: "Fracciones",
      dataIndex: "fracciones",
      className: "letraPequenaVisor",
      key: "fracciones",
      fixed: "left",
      sorter: (a, b) => a.fracciones - b.fracciones,
      sortDirections: ["descend", "ascend"],
      // ...getColumnStock("fracciones"),
    },

    {
      title: "Ma",
      dataIndex: "Ma",
      className: "letraPequenaVisor",
      key: "Ma",
      sorter: (a, b) => a.MA - b.MA,
      sortDirections: ["descend", "ascend"],
      ...getColumnStock("MA"),
    },
    {
      title: "M1",
      dataIndex: "M1",
      className: "letraPequenaVisor",
      key: "M1",
    },
    {
      title: "M2",
      dataIndex: "M2",
      className: "letraPequenaVisor",
      key: "M2",
    },
    {
      title: "M3",
      dataIndex: "M3",
      className: "letraPequenaVisor",
      key: "M3",
    },
    {
      title: "M4",
      dataIndex: "M4",
      className: "letraPequenaVisor",
      key: "M4",
    },
    {
      title: "M5",
      dataIndex: "M5",
      className: "letraPequenaVisor",
      key: "M5",
    },
    {
      title: "M6",
      dataIndex: "M6",
      className: "letraPequenaVisor",
      key: "M6",
    },
    {
      title: "M7",
      dataIndex: "M7",
      className: "letraPequenaVisor",
      key: "M7",
    },
    {
      title: "M8",
      dataIndex: "M8",
      className: "letraPequenaVisor",
      key: "M8",
    },
  ];

  return (
    <Card>
      <Table
        className='custom-table-visor'
        pagination={false}
        columns={columnsBodegaStock}
        scroll={{ x: 900, y: 430 }}
        size='small'
        bordered
        loading={loader}
        dataSource={dataStock ? dataStock : []}
      />
    </Card>
  );
};

export default StockFarmaciasTable;
